import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { EmployerOfRecordCountry } from "@oysterhr/schema"

export const VENDORS_STAFF_GET_VENDOR_COUNTRIES = gql`
  query VendorsStaffGetVendorCountries {
    employerOfRecordCountries {
      alpha2
      id
    }
  }
`

export const useEmployerOfRecordCountries = () =>
  useQuery<{ employerOfRecordCountries: EmployerOfRecordCountry[] }>(
    VENDORS_STAFF_GET_VENDOR_COUNTRIES,
  )
